import React from 'react';

const AppComingSoon = () => {
  return (
    <section className="py-32 px-6 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-rose/10 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Content - First on both mobile and desktop */}
          <div className="md:pl-8">
            <div className="inline-block px-4 py-2 bg-green-100 rounded-full text-sm font-medium mb-6 text-green-700">
              Available Now on Android
            </div>
            <h2 className="text-3xl md:text-4xl font-playfair font-light mb-6 text-charcoal">
              Your Perfect Match,
              <span className="block font-bold">In Your Pocket</span>
            </h2>
            <p className="text-charcoal/70 mb-10 leading-relaxed">
              Download Wako on Google Play and start finding meaningful connections wherever you are. iOS coming soon.
            </p>
            
            {/* Phone Mockup - Visible only on mobile */}
            <div className="relative flex justify-center mb-10 md:hidden">
              <div className="relative">
                {/* Main phone */}
                <div className="w-64 h-[500px] bg-charcoal rounded-[2.5rem] p-1.5 shadow-2xl">
                  <div className="w-full h-full bg-gradient-to-b from-offwhite to-blush rounded-[2rem] overflow-hidden flex flex-col">
                    {/* Status bar */}
                    <div className="px-5 py-2.5 flex justify-between text-[10px] text-charcoal">
                      <span>9:41</span>
                      <div className="flex gap-1">
                        <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                        <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                        <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                      </div>
                    </div>
                    
                    {/* Content */}
                    <div className="flex-1 px-5 flex flex-col justify-center items-center">
                      <div className="text-4xl font-playfair font-black gradient-text mb-2">wako</div>
                      <div className="text-[10px] text-charcoal/60 mb-5">Find Your Own</div>
                      
                      {/* Profile cards preview */}
                      <div className="space-y-2.5 w-full">
                        <div className="h-28 bg-white/80 backdrop-blur rounded-xl shadow-sm"></div>
                        <div className="h-20 bg-white/60 backdrop-blur rounded-xl shadow-sm"></div>
                        <div className="h-16 bg-white/40 backdrop-blur rounded-xl shadow-sm"></div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            
            {/* Features list with inline store buttons on the last row (desktop) */}
            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-rose rounded-full"></div>
                <span className="text-charcoal/80">Real-time notifications</span>
              </div>
              <div className="flex items-center gap-3 flex-wrap">
                <div className="w-2 h-2 bg-rose rounded-full"></div>
                <span className="text-charcoal/80">Seamless messaging</span>
                {/* Desktop inline store buttons (moved up) */}
                <div className="hidden md:flex items-center gap-3 ml-auto">
                  <div className="opacity-40">
                    <div className="flex items-center gap-2 bg-charcoal text-white px-3 py-2 rounded-lg whitespace-nowrap text-sm">
                      <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                      </svg>
                      <div className="text-left">
                        <div className="text-[9px] font-light leading-tight">Download on the</div>
                        <div className="text-xs font-semibold">App Store</div>
                      </div>
                    </div>
                  </div>
                  <a href="https://play.google.com/store/apps/details?id=zm.co.wako" target="_blank" rel="noopener noreferrer">
                    <div className="flex items-center gap-2 bg-charcoal text-white px-3 py-2 rounded-lg whitespace-nowrap text-sm hover:bg-rose transition-colors duration-300">
                      <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                      </svg>
                      <div className="text-left">
                        <div className="text-[9px] font-light leading-tight">Get it on</div>
                        <div className="text-xs font-semibold">Google Play</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-wrap">
                <div className="w-2 h-2 bg-rose rounded-full"></div>
                <span className="text-charcoal/80">Profile customization</span>
              </div>
              {/* Mobile store buttons below */}
              <div className="flex md:hidden gap-3">
                <div className="opacity-40">
                  <div className="flex items-center gap-2 bg-charcoal text-white px-3 py-2 rounded-lg whitespace-nowrap text-sm">
                    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <div className="text-left">
                      <div className="text-[9px] font-light leading-tight">Download on the</div>
                      <div className="text-xs font-semibold">App Store</div>
                    </div>
                  </div>
                </div>
                <a href="https://play.google.com/store/apps/details?id=zm.co.wako" target="_blank" rel="noopener noreferrer">
                  <div className="flex items-center gap-2 bg-charcoal text-white px-3 py-2 rounded-lg whitespace-nowrap text-sm hover:bg-rose transition-colors duration-300">
                    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                    <div className="text-left">
                      <div className="text-[9px] font-light leading-tight">Get it on</div>
                      <div className="text-xs font-semibold">Google Play</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

          </div>
          
          {/* Phone Mockup - Visible only on desktop */}
          <div className="relative hidden md:flex justify-center">
            <div className="relative">
              {/* Main phone */}
              <div className="w-64 h-[500px] bg-charcoal rounded-[2.5rem] p-1.5 shadow-2xl transform md:rotate-3">
                <div className="w-full h-full bg-gradient-to-b from-offwhite to-blush rounded-[2rem] overflow-hidden flex flex-col">
                  {/* Status bar */}
                  <div className="px-5 py-2.5 flex justify-between text-[10px] text-charcoal">
                    <span>9:41</span>
                    <div className="flex gap-1">
                      <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                      <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                      <div className="w-1 h-1 bg-charcoal rounded-full"></div>
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 px-5 flex flex-col justify-center items-center">
                    <div className="text-4xl font-playfair font-black gradient-text mb-2">wako</div>
                    <div className="text-[10px] text-charcoal/60 mb-5">Find Your Own</div>
                    
                    {/* Profile cards preview */}
                    <div className="space-y-2.5 w-full">
                      <div className="h-28 bg-white/80 backdrop-blur rounded-xl shadow-sm"></div>
                      <div className="h-20 bg-white/60 backdrop-blur rounded-xl shadow-sm"></div>
                      <div className="h-16 bg-white/40 backdrop-blur rounded-xl shadow-sm"></div>
                    </div>
                  </div>
                </div>
              </div>
              

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppComingSoon;